<template>
  <div class="container">
    <ul class="nav nav-tabs nav-tabs-c">
      <li role="presentation" v-link="{path: '/train/normal', activeClass: 'active'}" ><a href="#">报名中的培训</a></li>
      <li role="presentation" v-link="{path: '/train/history', activeClass: 'active'}" ><a href="#">历史培训</a></li>
      <li role="presentation" v-link="{path: '/train/cancel', activeClass: 'active'}" ><a href="#">取消的培训</a></li>
      <li role="presentation" class="pull-right">
        <button class="btn btn-primary" @click="showTrain({})">新增培训</button>
      </li>
    </ul>
    <!-- normal -->
    <div class="row flex-row" v-if="$route.params.status === 'normal' || $route.params.status === 'history'">
      <div class="col-xs-6" v-for="item in list" track-by="$index">
        <div class="panel panel-info">
          <div class="panel-heading">
            <div class="clearfix">
              <div class="pull-left">
              <button class="btn btn-xs btn-info" type="button" @click="showLeader(item)">添</button>
              <span class="text-danger">
              {{item.name}} [{{item.catalog}}]
              </span>
              {{item.meetPlace}}
              {{item.meetTime}}
              </div>
              <div class="pull-right">
                {{item.leaderSize}}/{{item.size}}
                <a href="javascript:void(0)" @click="showTrain(item)" class="btn-link">
                  修改
                </a>
                <a href="#" @click="removeTrain(item)" class="btn-link">
                  取消
                </a>
              </div>
            </div>
          </div>
          <table class="table table-bordered text-center">
            <tbody>
              <tr v-for="leader in item.leaders" track-by="$index">
                <td>
                  <button type="button" class="btn btn-danger btn-xs" @click="click(removeLeader)($event, item, leader)">取消</button>
                </td>
                <td>{{leader.name}}</td>
                <td>{{leader.mobile}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- history or cancel -->
    <div class="row flex-row" v-if="$route.params.status === 'cancel'">
      <div class="col-xs-6" v-for="item in list" track-by="$index">
        <div class="panel panel-info">
          <div class="panel-heading">
            <div class="clearfix">
              <div class="pull-left">
              <span class="text-danger">
              {{item.name}} [{{item.catalog }}]
              </span>
              {{item.meetPlace}}
              {{item.meetTime}}
              </div>
              <div class="pull-right">
                {{item.leaderSize}}/{{item.size}}
              </div>
            </div>
          </div>
          <table class="table table-bordered text-center">
            <tbody>
              <tr v-for="leader in item.leaders" track-by="$index">
                <td>{{leader.name}}</td>
                <td>{{leader.mobile}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <aside :show.sync="isShowTrain" placement="right" header="培训" :width="400">
      <form class="form-horizontal">
        <div class="form-group text-center">
          <!-- <label class="radio-inline">
            <input type="radio">
            试走
          </label> -->
          <label class="radio-inline">
            <input type="radio" v-model="train.catalog" value="沙龙">
            沙龙
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="train.catalog" value="培训">
            培训
          </label>
        </div>
        <div class="form-group" v-if="train.catalog !== '培训'">
          <label for="name" class="col-xs-3 control-label">活动名称</label>
          <div class="col-xs-9">
            <input type="text" id="name" class="form-control" v-model="train.name">
          </div>
        </div>
        <div class="form-group" v-if="train.catalog === '培训'">
          <label for="name" class="col-xs-3 control-label">活动名称</label>
          <div class="col-xs-9">
            <select class="form-control" v-model="train.name">
              <option :value="null">-</option>
              <option v-for="item in trains" track-by="$index" :value="item">{{item}}</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="time" class="col-xs-3 control-label">集合时间</label>
          <div class="col-xs-9">
            <input type="text" id="time" class="form-control" v-model="train.meetTime" data-field="datetime">
          </div>
        </div>
        <div class="form-group">
          <label for="place" class="col-xs-3 control-label">集合地点</label>
          <div class="col-xs-9">
            <input type="text" id="place" class="form-control" v-model="train.meetPlace">
          </div>
        </div>
        <div class="form-group">
          <label for="num" class="col-xs-3 control-label">人数</label>
          <div class="col-xs-9">
            <input type="number" id="num" class="form-control" v-model="train.size">
          </div>
        </div>
        <div class="form-group">
          <label for="note" class="col-xs-3 control-label">备注</label>
          <div class="col-xs-9">
            <textarea class="form-control" id="note" v-model="train.remark" cols="30" rows="3"></textarea>
          </div>
        </div>
        <!--
        <div class="from-group">
          <div class="col-xs-9 col-xs-offset-3">
            <label>
              <input type="checkbox">
              立即通知 //todo
            </label>
          </div>
        </div>
        -->
        <div class="from-group">
          <div class="col-xs-9 col-xs-offset-3">
            <button class="btn btn-primary" type="button" @click="click(addTrain)($event)">提交</button>
          </div>
        </div>
      </form>
    </aside>
    <aside :show.sync="isShowLeader" placement="right" :header="train.name" :width="450">
      <form>
        <div class="form-group">
          <input type="text" class="form-control" v-model="leaderName" debounce="500" placeholder="search">
        </div>
      </form>
      <table class="table table-condensed">
        <tr v-for="item in leaders | filterBy leaderName in 'name' 'nickName'" track-by="$index">
          <td>
            <button class="btn btn-xs btn-success" type="button" @click="addLeader(train, item)">排</button>
          </td>
          <td>
            {{item.name}}({{item.nickName}})
          </td>
          <td>
            {{item.sex}} {{item.mobile}}
          </td>
          <td>
            <a v-link="'/giver/' + item.id" @click="isShowLeader = false" class="btn-link">管理</a>
          </td>
        </tr>
      </table>
    </aside>
  </div>
</template>
<script>
  import { tabset, tab, aside, datepicker } from 'vue-strap'
  import _ from 'lodash'
  import config from '../../libs/config'
  import utils from '../../libs/utils'

  export default {
    components: {
      tabset,
      tab,
      aside,
      datepicker
    },
    data () {
      return {
        leaderName: '',
        isShowTrain: false,
        isShowLeader: false,
        date: new Date().toLocaleDateString(),
        list: [],
        train: {},
        leaders: [],
        trains: [
          'CW理念培训'
        ]
      }
    },
    methods: {
      fetchTrain () {
        let params = {
          status: this.$route.params.status
        }
        return this.$http.get(`${config.apiM}/product/giver/train`, params)
          .then(({data}) => {
            this.list = data
          })
      },
      showTrain (train = {}) {
        this.isShowTrain = true
        this.train = Object.assign({}, train)
      },
      removeTrain (train) {
        if (!window.confirm('确认取消？')) {
          return Promise.reject()
        }
        return this.$http.delete(`${config.apiM}/product/giver/train/${train.id}`)
          .then(() => {
            this.list.$remove(train)
          })
      },
      addTrain () {
        let train = _.pick(this.train, [
          'name',
          'meetTime',
          'meetPlace',
          'size',
          'remark',
          'catalog'
        ])

        let action
        if (!this.train.id) {
          action = this.$http.post(`${config.apiM}/product/giver/train`, train)
        } else {
          action = this.$http.put(`${config.apiM}/product/giver/train/${this.train.id}`, train)
        }

        return action
          .then(({data}) => {
            this.isShowTrain = false
            this.fetchTrain()
          })
      },
      removeLeader (train, leader) {
        if (window.confirm('确认删除？')) {
          let params = {
            leaderId: leader.id
          }
          return this.$http.delete(`${config.apiM}/product/giver/train/${train.id}/leader`, params)
            .then(() => {
              train.leaders.$remove(leader)
              train.leaderSize--
            })
        }
        return Promise.reject()
      },
      addLeader (train, leader) {
        return this.$http.post(`${config.apiM}/product/giver/train/${train.id}/leader`, { leaderId: leader.id })
          .then(({data}) => {
            this.fetchTrain()
          })
      },
      showLeader (train) {
        this.isShowLeader = true
        this.train = train
        if (!this.leaders.length) {
          this.$http.get(config.api + '/product/giver/leader')
            .then(function ({data}) {
              this.leaders = data
            })
        }
      },
      click: utils.click
    },
    route: {
      data ({next}) {
        this.fetchTrain()
        next()
      }
    }
  }
</script>
<style scoped>
  .nav-tabs-c {
    margin-bottom: 20px;
  }
  .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
</style>



/** WEBPACK FOOTER **
 ** Train.vue?3d2dd238
 **/